import UsersConfig from './UsersConfig';

import React, { useEffect, useState } from 'react';
import MenuBar from '../../utils/MenuBar';
import { Button, Form } from 'react-bootstrap';
import CompanySetting from './CompanySetting';

import MoreHorizIcon from '@mui/icons-material/MoreHoriz';

import SubscriptionsOutlinedIcon from '@mui/icons-material/SubscriptionsOutlined';

import ProfileSettings from './ProfileSettings';
import { useAuth } from 'react-oidc-context';
import QuickAccessBar from '../../utils/QuickAccessBar';
import { ButtonBase, ThemeProvider } from '@mui/material';
import SSIDSettings from './SSIDSettings';
import Payment from './PaymentSetting';
import Subscription from './SubscriptionSetting';
import HomeLayout from '../../utils/HomeLayout';
import { darkTheme } from '../../utils/funtions';

import { useLocation, useNavigate } from 'react-router-dom';

import MailOutlineIcon from '@mui/icons-material/MailOutline';
import PeopleOutlineIcon from '@mui/icons-material/PeopleOutline';
import WorkpaperTemplateSettings from './WorkpaperTemplateSettings';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import ArticleOutlinedIcon from '@mui/icons-material/ArticleOutlined';
import FaxOutlinedIcon from '@mui/icons-material/FaxOutlined';
import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';
import AccountingSoftwareSettings from './AccountingSoftwareSettings';
import SearchIcon from '@mui/icons-material/Search';
import HandshakeOutlinedIcon from '@mui/icons-material/HandshakeOutlined';
import BorderColorIcon from '@mui/icons-material/BorderColor';
import EmailTemplateSettings from './EmailTemplateSettings';
import SharepointConnectionSettings from './SharepointConnection';
import OutlookSettings from './OutlookSettings';  // ← new import

export default (props) => {

    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const navigate = useNavigate()

    const [currentComponent, setCurrentComponent] = useState(params.get('tab')? params.get('tab'): 'CompanySettings');
    const [currentTitle, setCurrentTitle ] = useState('Organization')

    const updateQueryParam = (value) => {
        const params = new URLSearchParams(location.search);
        params.set('tab', value);
        navigate(`${location.pathname}?${params.toString()}`);
    };

    const handleClick = (componentName, titleName) => {
        setCurrentComponent(componentName);
        setCurrentTitle(titleName)
    };

  useEffect(() => {
    updateQueryParam(currentComponent);
  }, [currentComponent]);

    useEffect(() => {
        const params = new URLSearchParams(location.search);
        setCurrentComponent(params.get('tab')? params.get('tab'): 'CompanySettings')
    }, [location.search]);


      return (
        <div className='mainContainer' style={{display: 'flex', padding: 0, fontSize: '0.9vw', backgroundColor: 'rgb(254, 254, 255, 0.85)', height: '81vh', border: '2px solid rgb(254, 254, 255, 0.3)', margin: '2vw', marginBottom: 0, borderRadius: '2vw', overflow: 'hidden'}}>

            <div style={{ display: 'flex', flexDirection: 'row', width: '100%', flex: 1 }}>

                {/* ── Left sidebar ───────────────────────────────────── */}
                <div style={{ width: '50%', textAlign: 'left', flex: 2, borderRadius: '1.5vw', padding: '1.5vw' , overflowY: 'auto'}}>
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
                        
                        <div style={{ display: 'none', backgroundColor: 'rgb(254, 254, 255, 0.6)', borderRadius: '0.8vw', padding: '0.5vw', paddingLeft: '1vw', width: '100%', color: 'rgb(0, 15, 30, 0.7)', marginBottom: '1.5vw'}}>
                            <ThemeProvider theme={darkTheme}>
                                <SearchIcon style={{fontSize: '1.2vw'}}/>
                            </ThemeProvider>
                            <Form.Control
                                id="client-search-bar"
                                style={{
                                    display: 'inline', backgroundColor: 'rgba(255,255,255,0)', padding: 0, paddingLeft: '0.5vw',
                                    border: '1px solid rgb(254, 254, 255, 0)', borderRadius: '6px', fontSize: '1vw', maxWidth: '80%', marginLeft:'0', fontWeight: '200'
                                }}
                                className='shadow-none'
                                type="text"
                                placeholder="Search"
                            />
                        </div>

                        <div style={{flex: 1, width: '100%'}}>

                            {/* ── General ──────────────────────────────── */}
                            <div style={{width: '100%', marginBottom: '1.5vw'}}>
                                <p style={{color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.8vw', paddingLeft: '0.5vw', margin: 0, marginBottom: '0.8vw'}}>General</p>
                                <div style={{backgroundColor:'rgb(254, 254, 255, 0.45)', width: '100%', borderRadius: '1vw', overflow: 'hidden'}}>
                                    <ButtonBase
                                        onClick={() => handleClick('Members', 'Members')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', borderBottom: '1px solid rgb(0, 15, 30, 0.05)', width: '100%',
                                            background: currentComponent === 'Members' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'Members' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><PeopleOutlineIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Team Members</h3>
                                    </ButtonBase>
                                    <ButtonBase
                                        onClick={() => handleClick('CompanySettings', 'Organization')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', width: '100%', borderBottom: '1px solid rgb(0, 15, 30, 0.05)',
                                            background: currentComponent === 'CompanySettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'CompanySettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><BusinessOutlinedIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Organization</h3>
                                    </ButtonBase>
                                    <ButtonBase
                                        onClick={() => handleClick('ATOSettings', 'Australian Tax Office')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', width: '100%', borderBottom: '1px solid rgb(0, 15, 30, 0.05)',
                                            background: currentComponent === 'ATOSettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'ATOSettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><FaxOutlinedIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Australian Tax Office</h3>
                                    </ButtonBase>
                                    <ButtonBase
                                        onClick={() => handleClick('SubscriptionSettings', 'Subscriptions')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', width: '100%',
                                            background: currentComponent === 'SubscriptionSettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'SubscriptionSettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><SubscriptionsOutlinedIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Subscriptions</h3>
                                    </ButtonBase>
                                    <ButtonBase
                                        onClick={() => handleClick('PaymentSettings', 'Payment')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', width: '100%',
                                            background: currentComponent === 'PaymentSettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'PaymentSettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><PaymentOutlinedIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Payment</h3>
                                    </ButtonBase>
                                </div>
                                
                            </div>

                            {/* ── Workpaper ─────────────────────────────── */}
                            <div style={{width: '100%', marginBottom: '1.5vw'}}>
                                <p style={{color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.8vw', paddingLeft: '0.5vw', margin: 0, marginBottom: '0.8vw'}}>Workpaper</p>
                                <div style={{backgroundColor:'rgb(254, 254, 255, 0.45)', width: '100%', borderRadius: '1vw', overflow: 'hidden'}}>
                                    <ButtonBase
                                        onClick={() => handleClick('AccountingSoftwareSettings', 'Accounting Software')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', borderBottom: '1px solid rgb(0, 15, 30, 0.05)', width: '100%',
                                            background: currentComponent === 'AccountingSoftwareSettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'AccountingSoftwareSettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><HandshakeOutlinedIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Accounting Software</h3>
                                    </ButtonBase>
                                    <ButtonBase
                                        onClick={() => handleClick('WorkpaperTemplateSettings', 'Workpaper Template')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', width: '100%',
                                            background: currentComponent === 'WorkpaperTemplateSettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'WorkpaperTemplateSettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><ArticleOutlinedIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Workpaper Template</h3>
                                    </ButtonBase>
                                </div>
                            </div>

                            {/* ── Communication ─────────────────────────── */}
                            <div style={{width: '100%', marginBottom: '1.5vw'}}>
                                <p style={{color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.8vw', paddingLeft: '0.5vw', margin: 0, marginBottom: '0.8vw'}}>Communication</p>
                                <div style={{backgroundColor:'rgb(254, 254, 255, 0.45)', width: '100%', borderRadius: '1vw', overflow: 'hidden'}}>
                                    <ButtonBase
                                        onClick={() => handleClick('EmailTemplateSettings', 'Email Template')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', width: '100%',
                                            borderBottom: '1px solid rgb(0, 15, 30, 0.05)',
                                            background: currentComponent === 'EmailTemplateSettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'EmailTemplateSettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><MailOutlineIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Email Template</h3>
                                    </ButtonBase>

                                    {/* ← NEW: Outlook Integration menu item */}
                                    <ButtonBase
                                        onClick={() => handleClick('OutlookSettings', 'Outlook Integration')}
                                        style={{
                                            textAlign: 'left', cursor: 'pointer', display: 'flex', alignItems: 'flex-start', flexDirection: 'column',
                                            padding: '1vw', width: '100%',
                                            background: currentComponent === 'OutlookSettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'OutlookSettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><MailOutlineIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Outlook Integration</h3>
                                    </ButtonBase>

                                </div>
                            </div>

                            <div style={{width: '100%', marginBottom: '1.5vw'}}>


                                    <p style={{color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.8vw', paddingLeft: '0.5vw', margin: 0, marginBottom: '0.8vw'}}>Document Classification</p>
                                    
                                    <div style={{backgroundColor:'rgb(254, 254, 255, 0.45)', width: '100%', borderRadius: '1vw', overflow: 'hidden'}}>
                                    
                                    <ButtonBase
                                        onClick={() => handleClick('SharepointConnectionSettings', 'Sharepoint Connection')}
                                        style={{
                                            textAlign: 'left',
                                            cursor: 'pointer',
                                            display: 'flex',
                                            alignItems: 'flex-start',
                                            flexDirection: 'column',
                                            padding: '1vw',
                                            width: '100%',
                                            background: currentComponent === 'EmailTemplateSettings' ? 'rgb(254, 254, 255, 0.8)' : 'transparent',
                                            color: currentComponent === 'EmailTemplateSettings' ? 'rgb(0, 15, 30, 0.7)': 'rgb(0, 15, 30, 0.6)',
                                        }}
                                    >
                                        <h3 style={{ fontSize: '0.9vw', fontWeight: '550', paddingBottom: '0', margin: 0}}><MailOutlineIcon style={{marginRight: '1vw', color: '#1c6c6c'}}/>Sharepoint Connection</h3>
                                    
                                    </ButtonBase>
                                    </div>

                                
                                
                                </div>

                        </div>
                    </div>
                </div>

                {/* ── Right panel ────────────────────────────────────── */}
                <div style={{ width: '50%', textAlign: 'left', flex: 5, overflowY: 'auto', backgroundColor: 'rgb(254, 254, 255, 0.2)' }}>

                    <div style={{display: currentComponent === 'AccountingSoftwareSettings'? 'inline': 'none'}}>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Accounting Software</h4>
                        <AccountingSoftwareSettings />
                    </div>

                    <div style={{display: currentComponent === 'WorkpaperTemplateSettings'? 'inline': 'none'}}>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Workpaper Template</h4>
                        <WorkpaperTemplateSettings />
                    </div>

                    <div style={{display: currentComponent === 'CompanySettings'? 'inline': 'none'}}>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Organization</h4>
                        <CompanySetting />
                    </div>

                    <div style={{display: currentComponent === 'Members'? 'inline': 'none'}}>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Team Members</h4>
                        <UsersConfig />
                    </div>

                    <div style={{display: currentComponent === 'SubscriptionSettings'? 'inline': 'none'}}>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Subscriptions</h4>
                        <Subscription />
                    </div>

                    <div style={{display: currentComponent === 'PaymentSettings'? 'inline': 'none'}}>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Payment</h4>
                        <Payment/>
                    </div>

                    {currentComponent === 'ATOSettings' && <>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Australian Tax Office</h4>
                        <SSIDSettings />
                    </>}

                    {currentComponent === 'EmailTemplateSettings' && <>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Email Template</h4>
                        <EmailTemplateSettings />
                    </>}

                    {/* ← NEW: Outlook Integration panel */}
                    {currentComponent === 'OutlookSettings' && <>
                        <h4 style={{ fontSize: '1.3vw', fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Outlook Integration</h4>
                        <OutlookSettings />
                    </>}

                    {currentComponent === 'SharepointConnectionSettings' && <>
                            <h4 style={{ fontSize: '1.3vw' , fontWeight: '600', marginBottom: '1.5vw', color: 'rgb(0, 15, 30, 0.8)', textAlign: 'center', marginTop: '1.5vw'}}>Sharepoint Connection</h4>
                            <SharepointConnectionSettings />
                    </>}

                </div>
            </div>

        </div>
    )

}
